module.exports = __webpack_public_path__ + "static/latte@2x-5d85c07e74ed2a8b9dd7b270157824a5.png";